import { useSelector } from 'react-redux'
import { hasContentType } from 'redux/actions/user'
import selectUserAccessRoles from 'redux/selectors/selectAccessRoles'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const useMenu = (menuSelector) => {
  const menuItems = useSelector(menuSelector)
  const isLogged = useSelector(selectIsLogged)
  const accessRoles = useSelector(selectUserAccessRoles)
  // At the moment logged out users get the full menu

  const restrict = isLogged
  const menu = [...menuItems]

  return !restrict
    ? menu.map((linkConfig) => {
      if (linkConfig.alternativeUrl) {
        return { ...linkConfig, url: linkConfig.alternativeUrl, externalLink: true }
      }
      return linkConfig
    })
    : menu.filter((item) => {
      if (!item.roles || item.roles.length === 0) return true
      return hasContentType(accessRoles, ...item.roles)
    })
}

export default useMenu
